export default {
  TOGGLE_HOME: 'TOGGLE_HOME',
  TOGGLE_POPUP_BOX: 'TOGGLE_POPUP_BOX',
  TOGGLE_EXIT_SHOWN: 'TOGGLE_EXIT_SHOWN',
  TOGGLE_LOGIN: 'TOGGLE_LOGIN',
  TOGGLE_OPEN: 'TOGGLE_OPEN'
};
